
import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
        import CryptoJS from 'crypto-js';
        import config from 'react-global-configuration';
class ManageFilter extends Component {
    constructor() {
        super();
                var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
                var localdata = has_local_data?this.decrypt(localStorage.getItem('encdata'), 0):'';
                this.state = {
            message:'',
                        apiUrl:this.decryptconfigdata('apiUrl'),
                        userAuthKey:has_local_data?localdata.user_key:'',
                        userId:has_local_data?localdata.user_id:'',
            history:'',
            filter_list:[],
            loading:1
        };
    }
        decryptconfigdata(configkey){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return plaintext;
        }
  
        decrypt(findresponse, flg){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var res = flg ? findresponse.encdata : findresponse;
                var bytes = CryptoJS.AES.decrypt(res, key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(plaintext);
        }
           rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    deltefilter(filterid)
    {
        if (window.confirm('Are you sure delete this filter')) {
        fetch(this.state.apiUrl + '/TicketRest/DeleteFilterList/id/' + filterid + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((findresponse) =>
            {
                
                findresponse = this.rawjsonparse(findresponse, 1);
                        if (findresponse.code == 200){
                    // window.location.href='/tickets/'; 
                    this.ManageFilterdetails();
                } else {
                
                    this.setState({message:findresponse.msg}) 
                }
            })
        }
    }
    defaultSelete(filterid){
        fetch(this.state.apiUrl + '/TicketRest/ChangeDefaultValue/id/' + filterid + '/userAuthKey/' + this.state.userAuthKey + '/userid/' + this.state.userId)
                .then((Response) => Response.json())
                .then((findresponse) =>
        {
                findresponse = this.rawjsonparse(findresponse, 1);
                        if (findresponse.code == 200){
                this.ManageFilterdetails();
            } else {
            
                this.setState({message:findresponse.msg}) 
            }
        })
    }
    ManageFilterdetails(){
        fetch(this.state.apiUrl + '/TicketRest/FilterList/userAuthKey/' + this.state.userAuthKey + "/userid/" + this.state.userId)
                .then((Response) => Response.json())
                .then((responseJson) =>
                {
                responseJson = this.rawjsonparse(responseJson, 1);
                        this.setState({
                            loading:0,
                            filter_list:responseJson.filter_list
                        }) 
                })
    }
    componentDidMount()
    {
        document.title = "Intranet | Manage Filter";
                if (!localStorage.getItem('userLogin')){
            this.setState({redirect:true});
          }
        this.ManageFilterdetails();
    } 
   getFilterDetails(){
        if (this.state.loading){
        return (
            <div>
            <div class="loader-new"></div>
          </div>
        )
        } else{
       return(
        <div class="tickets">
        <ul class="tickets_head">
            <li class="intra_col_33 text-center">Filter Name</li>
            <li class="intra_col_33 text-center">	Set As Default</li>
            <li class="intra_col_33 text-center">Action</li>
           
        </ul>
        <ul class="tickets_number" >
              <li class="intra_col_33 text-center">All</li>
              <li class="intra_col_33 manage_ticket text-center"> 
                  <label>
                <input type="radio" name="set_deafult" value="0" onClick={() => this.defaultSelete(0)} checked={0 == 0}/>
                      <span></span>
                  </label>
              </li>
         </ul>
        {
                this.state.filter_list.map((filter, key) =>
              <ul class="tickets_number" >
                  <li class="intra_col_33 text-center">{filter.name}</li>
                  <li class="intra_col_33 manage_ticket text-center">
                  <label>
                <input type="radio" id="set_deafult" name="set_deafult" value={filter.id} onClick={() => this.defaultSelete(filter.id)} checked={filter.is_default == 1}/>
                      <span></span>
                  </label>
                      </li>
                  
                  {/* <li class="intra_col_33 text-center">{filter.is_default!=1?<div className="details_des tooltips"><span  class="color-red" onClick={() => this.deltefilter(filter.id)} ><i class="fa fa-trash"></i><span class="tooltiptext tooltip-top">Delete</span></span></div>:''}</li>   */}
        <li class="intra_col_33 text-center">{filter.is_default != 1?<div className="details_des"><span  class="color-red" onClick={() => this.deltefilter(filter.id)} ><i class="fa fa-trash"></i></span></div>:''}</li>  
              </ul>
               )
          }
    </div>
       )
   }
}
goBack() {
    window.history.back();
}
    render() {
        if (this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
          } 
        return (
               <div >
                   <Header brecum_name="Support" brecum_page="Manage Filter"/>
    <div class="right_col">
              {this.state.message}
            <div class="intranet_body">
                <div class="title mob">
                        <HeaderMob page_name="Manage Filter"/>
                    </div>
                     {this.getFilterDetails()}
                     <div className="form-section ckeditor">
                <button type="buttom" name="add_note" id="add_note" className="btn btn-blue mob-btn" onClick={() => this.goBack()}>Back</button>
                     </div>
                      </div>
                      </div>
                 </div>
                );
    }
}
export default ManageFilter;


// WEBPACK FOOTER //
// ./src/components/support/ManageFilter.js